import type { FC } from 'react';

import { EnquirySelectionListCheckbox } from './EnquirySelectionListCheckbox';
import { EnquirySelectionListItems } from './EnquirySelectionListItems';
import { EnquirySelectionListNotFound } from './EnquirySelectionListNotFound';
import { EnquirySelectionListSearch } from './EnquirySelectionListSearch';

export const EnquirySelectionList: FC = () => {
	return (
		<>
			<EnquirySelectionListSearch />
			<EnquirySelectionListCheckbox />
			<EnquirySelectionListNotFound />
			<EnquirySelectionListItems />
		</>
	);
};
